export default __webpack_public_path__ + "static/media/NHP_Irrigation_KBJNL_Weekly_Report_Rabi2022-23_20230324.95ef3c20.pdf";